import { Box, keyframes } from '@mui/material'

const fadeAnimation = keyframes`
  0%, 80%, 100% {
    opacity: 1;
  }
  40% {
    opacity: 0.3;
  }
`

interface EllipsisLoadingProps {
  size?: number
  color?: string
}

const EllipsisLoading: React.FC<EllipsisLoadingProps> = ({ size = 4, color = 'text.primary' }) => {
  const dots = [0, 1, 2]

  return (
    <Box display="inline-flex" alignItems="center" gap={`${size * 0.5}px`} ml={1}>
      {dots.map((i) => (
        <Box
          key={i}
          sx={{
            width: size,
            height: size,
            borderRadius: '50%',
            backgroundColor: color,
            animation: `${fadeAnimation} 1.4s ease-in-out ${i * 0.16}s infinite both`,
          }}
        />
      ))}
    </Box>
  )
}

export default EllipsisLoading
